<section class="mx-auto mt-8 max-w-md rounded-xl border border-subtle bg-surface p-6 shadow-lg">
  <header class="mb-6 text-center">
    <h1 class="text-2xl font-semibold text-text">Sign In</h1>
    <p class="mt-2 text-sm text-text-muted">Continue with your Numerical account.</p>
  </header>

  <form class="grid gap-4" [formGroup]="signInForm" (ngSubmit)="onEmailSignIn()">
    <div class="grid gap-1">
      <label for="email" class="text-sm font-medium text-text">Email</label>
      <input
        id="email"
        type="email"
        formControlName="email"
        class="rounded-lg border border-subtle bg-surface px-3 py-2 text-text"
        autocomplete="email"
      />
      @if (signInForm.controls.email.touched && signInForm.controls.email.invalid) {
        <small class="text-sm text-red-600">Enter a valid email address.</small>
      }
    </div>

    <div class="grid gap-1">
      <label for="password" class="text-sm font-medium text-text">Password</label>
      <input
        id="password"
        type="password"
        formControlName="password"
        class="rounded-lg border border-subtle bg-surface px-3 py-2 text-text"
        autocomplete="current-password"
      />
      @if (signInForm.controls.password.touched && signInForm.controls.password.invalid) {
        <small class="text-sm text-red-600">Password must be at least 6 characters.</small>
      }
    </div>

    @if (errorMessage(); as message) {
      <p class="rounded-lg border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700">
        {{ message }}
      </p>
    }

    <button
      type="submit"
      class="rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-contrast transition-opacity duration-200 ease-in-out hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-70"
      [disabled]="isSubmitting()"
    >
      {{ isSubmitting() ? 'Signing in...' : 'Sign In' }}
    </button>
  </form>

  <div class="my-5 flex items-center gap-3">
    <span class="h-px flex-1 bg-subtle"></span>
    <span class="text-xs uppercase tracking-wider text-text-muted">Or</span>
    <span class="h-px flex-1 bg-subtle"></span>
  </div>

  <button
    type="button"
    class="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-subtle px-4 py-2 text-sm font-medium text-text transition-colors duration-200 ease-in-out hover:bg-surface-muted disabled:cursor-not-allowed disabled:opacity-70"
    [disabled]="isSubmitting()"
    (click)="onGoogleSignIn()"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" class="h-5 w-5" aria-hidden="true">
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3C33.6 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.7 15 19 12 24 12c3 0 5.7 1.1 7.8 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2.1 1.6-4.7 2.4-7.2 2.4-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.4 39.6 16.1 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.6-2.4 4.7-4.7 6.2l.1-.1 6.2 5.2C36.5 39.6 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"
      />
    </svg>
    Continue with Google
  </button>
</section>
